import { Components, Theme } from '@mui/material';
import { Focused, Disabled } from '../color';
import getTransition from '../utilities/getTransition';
import { radioClasses, Sizes } from './constants';

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  defaultProps: {
    color: 'secondary',
    disableFocusRipple: true,
    focusRipple: false,
    disableRipple: true,
    centerRipple: false,
    disableTouchRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.secondary.main,
      boxSizing: 'border-box',
      position: 'relative',
      padding: 6,
      marginInlineEnd: 4,
      ':hover': {
        background: theme.palette.action.hover,
      },
      [`.${radioClasses.iconContainer}`]: {
        boxSizing: 'border-box',
        borderColor: theme.palette.secondary.main,
        background: theme.palette.background.paper,
        width: Sizes.medium.icon,
        height: Sizes.medium.icon,
        borderRadius: Sizes.medium.icon,
        borderWidth: 1,
        borderStyle: 'solid',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        outlineColor: 'transparent',
        outlineOffset: 0,
        outlineWidth: 2,
        outlineStyle: 'solid',
        ...getTransition(['outline-color', 'outline-offset']),
      },
      [`.${radioClasses.dot}`]: {
        backgroundColor: theme.palette.secondary.main,
        opacity: 0,
        width: Sizes.medium.dot / 3,
        height: Sizes.medium.dot / 3,
        borderRadius: Sizes.medium.dot,
        ...getTransition(['width', 'height', 'opacity']),
      },
      [`input:focus-visible + .${radioClasses.iconContainer}`]: {
        outlineColor: Focused.main,
        outlineOffset: 4,
      },
      [`&.${radioClasses.checked}`]: {
        [`.${radioClasses.dot}`]: {
          opacity: 1,
          width: Sizes.medium.dot,
          height: Sizes.medium.dot,
        },
      },
      [`&.${radioClasses.small}`]: {
        padding: 4,
        [`.${radioClasses.iconContainer}`]: {
          width: Sizes.small.icon,
          height: Sizes.small.icon,
          borderRadius: Sizes.small.icon,
        },
        [`.${radioClasses.dot}`]: {
          width: Sizes.small.dot / 3,
          height: Sizes.small.dot / 3,
          borderRadius: Sizes.small.dot,
        },
        [`input:focus-visible + .${radioClasses.iconContainer}`]: {
          outlineOffset: 2,
        },
        [`&.${radioClasses.checked}`]: {
          [`.${radioClasses.dot}`]: {
            width: Sizes.small.dot,
            height: Sizes.small.dot,
          },
        },
      },
      [`&.${radioClasses.disabled}`]: {
        [`.${radioClasses.iconContainer}`]: {
          backgroundColor: Disabled.default.main,
          borderColor: Disabled.default.text,
        },
        [`.${radioClasses.dot}`]: {
          backgroundColor: Disabled.default.text,
        },
      },
    }),
  },
};
